import mq from 'shared/mq';

export default class CoursesHeader {
  constructor(root) {
    this.root = root;

    const _this = this;

    mq.register('nav', {
      match() {
        _this.init();
      },
      unmatch() {
        _this.destroy();
      },
    });
  }

  init() {
    console.info('init');
    document.querySelector('.u-nav-header__bar').appendChild(this.root);
  }

  destroy() {
    console.info('destroy');
    document.querySelector('.u-courses-header-outer').appendChild(this.root);
  }
}
